import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FloatingChatButton = ({ onOpen, hidden }) => {
    const [presence, setPresence] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await axios.get(`${API}/mara/presence`);
                setPresence(res.data);
            } catch {
                setPresence(null);
            }
        };
        load();
        const t = setInterval(load, 15000);
        return () => clearInterval(t);
    }, []);

    if (hidden) return null;

    const online = !presence || presence.status === "online";
    const label = presence
        ? online
            ? "MARA IS AVAILABLE NOW"
            : "LEAVE YOUR MIRROR REQUEST"
        : "IS MARA INSIDE THE MIRROR?";

    return (
        <motion.button
            type="button"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.4, duration: 0.8 }}
            onClick={onOpen}
            data-testid="floating-chat-button"
            title="Is Mara inside the mirror?"
            className="fixed bottom-6 right-6 z-[70] flex items-center gap-3 rounded-full border border-[#c77dff]/50 bg-[#18002e]/85 px-5 py-3.5 shadow-[0_0_30px_rgba(123,44,191,0.5)] backdrop-blur-xl transition-[box-shadow,transform] duration-300 hover:scale-105 hover:shadow-[0_0_45px_rgba(199,125,255,0.65)] active:scale-95"
        >
            <span className="relative flex h-2.5 w-2.5">
                <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-60 ${online ? "bg-emerald-300" : "bg-amber-300"}`} />
                <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${online ? "bg-emerald-300" : "bg-amber-300"}`} />
            </span>
            <span className="font-cinzel text-[11px] tracking-[0.2em] text-[#f8f7ff]">{label}</span>
        </motion.button>
    );
};
